import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import InventoriesList from '@shared/inventories/InventoriesList'

import { inventoryService } from '@services/operator/inventoryService'
import { inventoryHoldService } from '@services/operator/inventoryHoldService'

export default function OperatorInventoriesList() {
  const { merchants, inventoryTypes } = useOperatorData()
  const isStandard = useIsStandard()
  const { addJob } = useOperatorNotification()
  const { t } = useTranslation()

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  const inventoryTypeOptions = useMemo(() => {
    return inventoryTypes
      .filter(it => it.name)
      .map(it => ({ label: it.name, value: it.name }))
  }, [inventoryTypes])

  return (
    <div>
      <ListPageHeader items={['stocks', 'stocks.list']} />
      <InventoriesList
        service={inventoryService}
        role="operator"
        merchantOptions={merchantOptions}
        inventoryTypeOptions={inventoryTypeOptions}
        addJob={addJob}
        holdService={inventoryHoldService}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
